<!-- 企业级-业务领域-仓储业务-添加出库单 -->
<template>
  <div class="mainArea CAddOutware">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <!-- 搜索框 -->
        <div class="searchBox">
          <div class="item">
            <div class="tit">订单号</div>
            <el-input class="searchInput" v-model="addForm.number" placeholder="订单号" clearable></el-input>
          </div>
          <div class="item">
            <div class="tit">出库批次</div>
            <el-input class="searchInput" v-model="addForm.wareBatch" placeholder="入库批次" clearable></el-input>
          </div>
          <div class="item">
            <div class="tit">客户</div>
            <el-input class="searchInput" v-model="addForm.custmer" placeholder="客户" clearable></el-input>
          </div>
          <div class="item item2">
            <div class="tit">备注</div>
            <el-input v-model="addForm.desc" placeholder="备注" clearable></el-input>
          </div>
        </div>
        <!-- 添加信息 -->
        <div class="addButton">
          <el-input class="w300" v-model="addForm.RFIDInp" placeholder="请连接扫描设备或者手动逐个添加RFID"></el-input>
          <el-button type="primary">添加</el-button>
        </div>

        <el-table v-loading="loading" :data="bookData" style="width: 100%">
          <el-table-column type="index" label="序号" width="80"></el-table-column>
          <el-table-column label="产品编号" prop=""></el-table-column>
          <el-table-column label="产品名称" prop=""></el-table-column>
          <el-table-column label="类别" prop=""></el-table-column>
          <el-table-column label="规格" prop=""></el-table-column>
          <el-table-column label="供应商" prop=""></el-table-column>
          <el-table-column label="生产日期" prop=""></el-table-column>
          <el-table-column label="有效期" prop=""></el-table-column>
          <el-table-column label="仓库" prop=""></el-table-column>
          <el-table-column label="库位" prop=""></el-table-column>
          <el-table-column label="货架" prop=""></el-table-column>
          <el-table-column label="货位" prop=""></el-table-column>
          <el-table-column label="入库数" prop=""></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="openDio('edit')">修改</el-button>
              <el-button type="text">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paging" v-if="total>limits">
          <el-pagination
            @current-change="CurrentChange"
            :current-page.sync="curr"
            :page-size="limits"
            layout="prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
        <div class="btnDiv">
          <el-button size="medium" @click="backUp">取消</el-button>
          <el-button size="medium" type="primary">确定</el-button>
        </div>
      </div>

      <el-dialog :title="dioTitle" :visible.sync="bookDio" :width="dioWidth" class="configDio" center>
        <div class="contDio">
          <el-table :data="dioform.RFIDlist" style="width: 100%" max-height="270px">
            <el-table-column type="index" label="序号" width="80"></el-table-column>
            <el-table-column label="RFID编号" prop=""></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">[ - ]</template>
            </el-table-column>
          </el-table>
          <div class="paging" v-if="dioform.total>dioform.limits">
            <el-pagination
              @current-change="CurrDioChange"
              :current-page.sync="dioform.curr"
              :page-size="dioform.limits"
              layout="prev, pager, next, jumper"
              :total="dioform.total">
            </el-pagination>
          </div>
        </div>
        <span slot="footer">
          <el-button @click="bookDio = false">取消</el-button>
          <el-button type="primary">确定</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../../static/js/utility/utility.js"

  export default {
    name: 'CAddOutware',
    components: {
      CBreadCrumb,
    },
    data() {
      return {
        addForm:{
          number:'',//订单号
          wareBatch:'',//入库批次
          custmer:'',//客户
          desc:'',//备注
          RFIDInp:'',//RFID
        },

        loading:false,
        bookData:[{id:'1'}],//仓库数据

        //分页
        curr:1,
        limits:10,
        total:0,

        bookDio:false,//弹窗
        dioTitle:'',//弹窗标题
        dioWidth:'',//弹窗宽度
        dioType:'',//弹窗类型
        dioform:{
          RFIDlist:[],
          //分页
          curr:1,
          limits:10,
          total:0,
        },
      };
    },
    mounted(){

    },
    created: async function () {
      
    },
    methods: {
      //打开弹窗
      openDio(type){
        this.dioType = type
        if(type == 'edit'){
          this.dioWidth="600px"
          this.dioTitle="修改出库产品"
        }
        this.bookDio = true
      },
      //弹窗分页
      CurrDioChange(val){
        this.dioform.curr = val
        //执行方法
      },
      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
      },
      //返回上一页
      backUp(){
        this.$router.push({
          path:'/COutInWareManage',
          query:{
            type:'out'
          }
        })
      }
    },
    watch: {
      
    }
  }
</script>

<style lang="scss">
.CAddOutware{
  .w200{
    width: 200px;
  }
  .w300{
    width: 300px;
  }
  .w235{
    width: 235px;
  }
  .w480{
    width: 480px;
  }
  .btnDiv{
    margin-top: 20px;
    text-align: right;
  }
  .searchBox {
    margin-bottom: 20px;
    .item{
      display: inline-block;
      margin-right: 20px;
      margin-bottom: 10px;
      .tit{ padding-bottom: 10px; }
      &.item2{
        width: 100%;
      }
    }
    .searchInput {
      width: 235px;
    }
  }
  .contDio{
    .el-form-item{
      margin-bottom: 10px;
      .el-form-item__content{
        line-height: 1.5;
      }
    }
  }
  .addButton {
    margin-bottom: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CStorage/COutInWareManage/CAddOutware.vue